
<tilby-dialog-toolbar [title]="data.title" class="tw-px-5" (confirm)="confirm()"/>
<tilby-dialog-content>
    <p>{{data.content | translate}}</p>
    <p>{{data.subContent! | translate}}</p>
    <tilby-magic-form [form]="datePickerForm"/>
</tilby-dialog-content>
